export enum THomepagePersonalizationVariation {
  Default = 0,
  V2 = 1
}

export enum TGameEmphasisVariation {
  V2 = '1',
  Default = '0'
}
